import { render, staticRenderFns } from "./UploadError.vue?vue&type=template&id=6cf9e63e&"
import script from "./UploadError.vue?vue&type=script&lang=js&"
export * from "./UploadError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UploadError.vue"
export default component.exports